const questionList = [
  {
    id:1,
    type:'sociality',
    question:'母猫と１カ月以上いっしょに暮らしていましたか？',
    cat_l:'8',
    cat_r:'6'
  },
  {
    id:2,
    type:'sociality',
    question:'子猫のころ、ほかの兄弟姉妹といっしょに暮らしていましたか？',
    cat_l:'7',
    cat_r:'5'
  },
  {
    id:3,
    type:'sociality',
    question:'生後６か月の間、親兄弟姉妹やほかの猫といっしょに暮らしていましたか？',
    cat_l:'3',
    cat_r:'10'
  },
  {
    id:4,
    type:'sociality',
    question:'ほかの猫となかよくいっしょに暮らしていたことはありますか？',
    cat_l:'9',
    cat_r:'1'
  },
  {
    id:5,
    type:'sociality',
    question:'ほかの猫をじょうずに受け入れた経験はありますか？',
    cat_l:'6',
    cat_r:'4'
  },
  {
    id:6,
    type:'sociality',
    question:'ほかの猫と仲良くできますか？',
    cat_l:'7',
    cat_r:'3'
  },
  {
    id:7,
    type:'sociality',
    question:'ほかの猫とくっついていっしょに寝ることはありますか？',
    cat_l:'8',
    cat_r:'5'
  },
  {
    id:8,
    type:'nature',
    question:'ほかの猫を見るとシャーとかウーとかいいますか？',
    cat_l:'1',
    cat_r:'10'
  },
  {
    id:9,
    type:'nature',
    question:'ほかの猫と会ったとき、相手の猫に興味を示しますか？',
    cat_l:'4',
    cat_r:'9'
  },
  {
    id:10,
    type:'nature',
    question:'遊ぶことは好きですか？',
    cat_l:'5',
    cat_r:'6'
  },
  {
    id:11,
    type:'nature',
    question:'はじめて見るものに対して興味を示しますか？',
    cat_l:'7',
    cat_r:'8'
  },
  {
    id:12,
    type:'nature',
    question:'どんな状況でもおやつや好きなごはんは食べますか？',
    cat_l:'2',
    cat_r:'3'

  }
]

export { questionList }